import * as dm from '../domain';
import BaseView from "../views/base-view";
import ClosetUnitView from "../views/closet-unit-view";
import CubbyView from "../views/cubby-view";
import DomainModel from "../domain-model";
import DoorView from "../views/door-view";
import DrawerView from "../views/drawer-view";
import GenericAssetView from "../views/generic-asset-view";
import GroupView from "../views/group-view";
import ParametricPartView from "../views/parametric-part-view";
import RoomView from '../views/room-view';
import SlantedShelfView from "../views/slanted-shelf-view";
import WallView from "../views/wall-view";

export type ThumbnailRenderRequest = {
    width: number,
    height: number,
    modelType: ModelType,
    modelJSON: object,
};

export enum ModelType {
    ClosetUnit,
    Cubby,
    Door,
    Drawer,
    GenericAsset,
    Group,
    ParametricPart,
    Room,
    Wall,
    SlantedShelf,
}

export class ModelTypeError extends Error {};

export const encodeModelType = (model: DomainModel): ModelType => {
    switch(model.constructor) {
        case dm.ClosetUnit:
            return ModelType.ClosetUnit;
        case dm.Cubby:
            return ModelType.Cubby;
        case dm.Door:
            return ModelType.Door;
        case dm.Drawer:
            return ModelType.Drawer;
        case dm.GenericAsset:
            return ModelType.GenericAsset;
        case dm.Group:
            return ModelType.Group;
        case dm.ParametricPart:
            return ModelType.ParametricPart;
        case dm.Room:
            return ModelType.Room;
        case dm.Wall:
            return ModelType.Wall;
        case dm.SlantedShelf:
            return ModelType.SlantedShelf;
        default:
            throw `Unsupported model type "${model.constructor?.name}"`;
    }
}

export const constructModelAndViewByType = (type: ModelType, modelJSON: object): BaseView => {
    switch(type) {
        case ModelType.ClosetUnit: {
            const
                model = dm.ClosetUnit.fromJSON(modelJSON),
                view = new ClosetUnitView(model, {});
            return view;
        }
        case ModelType.Cubby: {
            const
                model = dm.Cubby.fromJSON(modelJSON),
                view = new CubbyView(model);
            return view;
        }
        case ModelType.Door: {
            const
                model = dm.Door.fromJSON(modelJSON),
                view = new DoorView(model);
            return view;
        }
        case ModelType.Drawer: {
            const
                model = dm.Drawer.fromJSON(modelJSON),
                view = new DrawerView(model);
            return view;
        }
        case ModelType.GenericAsset: {
            const
                model = dm.GenericAsset.fromJSON(modelJSON),
                view = new GenericAssetView(model);
            return view;
        }
        case ModelType.Group: {
            const
                model = dm.Group.fromJSON(modelJSON),
                view = new GroupView(model);
            return view;
        }
        case ModelType.ParametricPart: {
            const
                model = dm.ParametricPart.fromJSON(modelJSON),
                view = new ParametricPartView(model);
            return view;
        }
        case ModelType.Room: {
            const
                model = dm.Room.fromJSON(modelJSON),
                view = new RoomView(model);
            return view;
        }
        case ModelType.Wall: {
            const
                model = dm.Wall.fromJSON(modelJSON),
                view = new WallView(model, {});
            return view;
        }
        case ModelType.SlantedShelf: {
            const
                model = dm.SlantedShelf.fromJSON(modelJSON),
                view = new SlantedShelfView(model);
            return view;
        }
    }
}
